var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',[_vm._t("default")],2),_c('img',{attrs:{"src":("/icons/" + _vm.icon + ".svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }